import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

// Components
import { AbsolutePositioned } from '../../../components/Layout/AbsolutePositioned';
import { ContentContainer } from '../../../components/Layout/ContentContainer';
import { Screen, SplitScreen } from '../../../components/Layout/Screen';
import Title, { Highlight } from '../../../components/Title';
import TextBlock from '../../../components/TextBlock';
import ContactForm from '../../../components/ContactForm';
import SimpleInput from '../../../components/ContactForm/Inputs/Simple';
import UploadInput from '../../../components/ContactForm/Inputs/Upload';
import SealAnimation from '../../../components/SealAnimation';
import TextAreaInput from '../../../components/ContactForm/Inputs/TextArea';

// Assets
import { brandColors, device } from '../../../styles/variables';
import drawing from '../../../assets/images/pages/contact/kews_graphic.png';

const StyledScreen = Screen.extend`
  background: ${brandColors.yellow};
  height: auto;
  padding: 0 0 50px 0;
  @media ${device.tablet} {
    height: 100%;
    padding: 0;
  }
`;

const BackgroundOverlay = AbsolutePositioned.extend`
  background: url(${drawing}) bottom no-repeat;
  background-size: cover;
  width: 100%;
  height: 100%;
  opacity: 0.3;
`;

const ContentHolder = AbsolutePositioned.extend`
  width: 100%;
  height: 100%;
`;

const ContentSplitScreen = SplitScreen.extend`
  vertical-align: top;
  position: relative;
  display: block;
  height: auto;
  width: 100%;
  @media ${device.tablet} {
    height: 100%;
    width: 50%;
    display: inline-block;
  }
`;

const TextContent = AbsolutePositioned.extend`
  position: relative;
  top: unset;
  bottom: unset;
  left: unset;
  right: unset;
  @media ${device.tablet} {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    min-width: 350px;
    bottom: 310px;
  }

  &.contact-form {
    @media ${device.tablet} {
      bottom: 110px;
    }
    div:first-child {
      margin: 0;
    }
  }
`;

const SealContainer = styled.div`
  margin: 30px 0;
  @media ${device.tablet} {
    margin: 0;
    position: absolute;
    top: 75px;
    right: 37%;
  }
`;

const JoinTheTeamScreen = () => (
  <StyledScreen id="joinUs">
    <BackgroundOverlay />
    <ContentHolder>
      <ContentContainer>
        <SealContainer>
          <SealAnimation />
        </SealContainer>
        <ContentSplitScreen>
          <TextContent className="text-content" top="unset" bottom="310px">
            <Title primary={false}>
              Join <Highlight>the</Highlight> team
            </Title>
            <TextBlock>
              <p>
                We are always looking for in-house and freelance talent. Please send us your CV
                here.
              </p>
            </TextBlock>
          </TextContent>
        </ContentSplitScreen>
        <ContentSplitScreen>
          <TextContent top="unset" bottom="110px" className="contact-form">
            <ContactForm form="secondary" color={brandColors.blue}>
              <SimpleInput name="name" text="*name" />
              <SimpleInput name="email" text="*email" />
              <SimpleInput name="linkedin" text="your Linkedin Profile" />
              <TextAreaInput name="message" text="message" />
              <UploadInput name="cv_pdf" text="Attach your CV (.pdf)" />
            </ContactForm>
          </TextContent>
        </ContentSplitScreen>
      </ContentContainer>
    </ContentHolder>
  </StyledScreen>
);

export default connect()(JoinTheTeamScreen);



// WEBPACK FOOTER //
// ./src/pages/Contact/screens/JoinTheTeam.jsx